!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t(require("axios")) : "function" == typeof define && define.amd ? define(["axios"], t) : "object" == typeof exports ? exports["axios-auth-refresh"] = t(require("axios")) : e["axios-auth-refresh"] = t(e.axios);
}(this, function (e) {
  return function () {
    "use strict";

    var t = {
        593: function (e, t, r) {
          Object.defineProperty(t, "__esModule", {
            value: !0
          }), t.resendFailedRequest = t.getRetryInstance = t.unsetCache = t.createRequestQueueInterceptor = t.createRefreshCall = t.shouldInterceptError = t.mergeOptions = t.defaultOptions = void 0;
          const s = r(300);
          t.defaultOptions = {
            statusCodes: [401],
            pauseInstanceWhileRefreshing: !1
          }, t.mergeOptions = function (e, t) {
            return Object.assign(Object.assign(Object.assign({}, e), {
              pauseInstanceWhileRefreshing: t.skipWhileRefreshing
            }), t);
          }, t.shouldInterceptError = function (e, t, r, s) {
            var n, o;
            return !!e && !(null === (n = e.config) || void 0 === n ? void 0 : n.skipAuthRefresh) && !!(t.interceptNetworkError && !e.response && 0 === e.request.status || e.response && ((null == t ? void 0 : t.shouldRefresh) ? t.shouldRefresh(e) : null === (o = t.statusCodes) || void 0 === o ? void 0 : o.includes(parseInt(e.response.status)))) && (e.response || (e.response = {
              config: e.config
            }), !t.pauseInstanceWhileRefreshing || !s.skipInstances.includes(r));
          }, t.createRefreshCall = function (e, t, r) {
            return r.refreshCall || (r.refreshCall = t(e), "function" == typeof r.refreshCall.then) ? r.refreshCall : (console.warn("axios-auth-refresh requires `refreshTokenCall` to return a promise."), Promise.reject());
          }, t.createRequestQueueInterceptor = function (e, t, r) {
            return void 0 === t.requestQueueInterceptorId && (t.requestQueueInterceptorId = e.interceptors.request.use(e => t.refreshCall.catch(() => {
              throw new s.default.Cancel("Request call failed");
            }).then(() => r.onRetry ? r.onRetry(e) : e))), t.requestQueueInterceptorId;
          }, t.unsetCache = function (e, t) {
            e.interceptors.request.eject(t.requestQueueInterceptorId), t.requestQueueInterceptorId = void 0, t.refreshCall = void 0, t.skipInstances = t.skipInstances.filter(t => t !== e);
          }, t.getRetryInstance = function (e, t) {
            return t.retryInstance || e;
          }, t.resendFailedRequest = function (e, t) {
            return e.config.skipAuthRefresh = !0, t(e.response.config);
          };
        },
        300: function (t) {
          t.exports = e;
        }
      },
      r = {};
    function s(e) {
      var n = r[e];
      if (void 0 !== n) return n.exports;
      var o = r[e] = {
        exports: {}
      };
      return t[e](o, o.exports, s), o.exports;
    }
    var n = {};
    return function () {
      var e = n;
      Object.defineProperty(e, "__esModule", {
        value: !0
      });
      const t = s(593);
      e.default = function (e, r) {
        let s = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        if ("function" != typeof r) throw new Error("axios-auth-refresh requires `refreshAuthCall` to be a function that returns a promise.");
        const n = {
          skipInstances: [],
          refreshCall: void 0,
          requestQueueInterceptorId: void 0
        };
        return e.interceptors.response.use(e => e, o => {
          if (s = (0, t.mergeOptions)(t.defaultOptions, s), !(0, t.shouldInterceptError)(o, s, e, n)) return Promise.reject(o);
          s.pauseInstanceWhileRefreshing && n.skipInstances.push(e);
          const u = (0, t.createRefreshCall)(o, r, n);
          return (0, t.createRequestQueueInterceptor)(e, n, s), u.catch(e => Promise.reject(e)).then(() => (0, t.resendFailedRequest)(o, (0, t.getRetryInstance)(e, s))).finally(() => (0, t.unsetCache)(e, n));
        });
      };
    }(), n;
  }();
});